// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.anketa-wrap{max-width:600px!important;display:flex;flex-direction:column;align-items:center}@media (max-width:500px){.param-title,.param-value{font-size:14px!important}.text-title{font-size:16px!important}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
